<div class="col-sm-12 no-padding">

  <div class="col-sm-12 no-padding">
    <h4>Repasses </h4>
    <hr>
  </div>


  <div class="col-sm-12 no-padding animated fadeIn">
    <table class="table table-striped">
      <tbody>
        <tr>
          <th>Data do repasse</th>
          <th>Data de Envio</th>
          <th>Valor</th>
          <th class="text-center">Ações</th>
        </tr>
        <tr *ngFor="let item of listaRepasses">
          <td style="text-align: justify; font-size: 15px;">
            {{ item.obDataTransf | date:'dd/MM/yyyy' }}
            <!-- <div style="font-size: 12px; margin-left: 10px; margin-top: 7px;">
              <b class="text-light-blue"> <i class="fa fa-fw fa-angle-double-right"></i> Descrição:</b><br>
              <p style="margin-left: 18px;">{{ item.descricao }}</p>
            </div> -->
          </td>
          <td style="text-align: justify; font-size: 15px;">
            {{ item.dataSolicitacaoAnalise ? (item.dataSolicitacaoAnalise | date:'dd/MM/yyyy') : '-' }}
          </td>
          <td>
            R$ {{ item.obValorReceb | number:'.2' }}
          </td>
          <td class="text-center vcenter" style="width: 10%;">
            <span class="badge bg-blue cursor" pTooltip="Análise de contas" tooltipPosition="top" (click)="gotoAnaliseContas(item)">
              <i class="fas fa-cog"></i></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


</div>